import React from "react";
import styled from "styled-components";

const Wrapper = styled.footer`
  height: 40px;
  display: flex;
  align-items: flex-end;
  padding-bottom: 20px;
  justify-content: center;

  @media (min-width: 768px) {
    padding-bottom: 20px;
  }
`;

const Link = styled.a`
  color: ${(props) => props.theme.palette.primary};
  font-family: ${(props) => props.theme.typo.fontFamily};
  font-size: 12px;
  text-decoration: none;

  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

const Footer = () => {
  return (
    <Wrapper>
      <Link href="https://www.natif.ai/en/privacy/">Privacy</Link>
    </Wrapper>
  );
};

export default Footer;
